import { MenuItem, Select, Chip } from "@mui/material";
import { Component } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';

const CustomSelect = styled(Select)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline legend": { 
        display: "none", 
    }
}));

class CustomizedSelectWithChips extends Component {
    deleteItem(value) {
        this.props.onDelete(value);
    }

    render() {
        var {onDelete, noOptionsMessage, ...other} = this.props;
        return (this.props.label ?
            <Select
                {...other}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    transformOrigin: { vertical: "top", horizontal: "center" },
                    className: this.props.menuclasses
                }}
                renderValue={(selected) => {
                    if (this.props.multiple) {
                        return (
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                {selected.map(value => {
                                    return ( 
                                        <div key={value} style={{marginBottom: '5px', maxWidth: '100%'}}>                            
                                            <Chip
                                            key={value}
                                            label={this.props.options?.find(o => o.value === value)?.label}
                                            clickable
                                            deleteIcon={
                                                <CancelIcon
                                                    onMouseDown={(event) => {
                                                        event.stopPropagation();
                                                    }}
                                                />
                                                }
                                            onDelete={() => {
                                                this.deleteItem(value);
                                            }}
                                            sx={{
                                                maxWidth: "100%"
                                            }}

                                            />   
                                            &nbsp;    
                                        </div>                 
                                    );
                                })}
                            </div>
                        )  
                    }                                                 
                }}
            >
                {this.props.children ?? this.props.options.map((o) => (
                    <MenuItem key={o.value + o.label} value={o.value}>
                        {o.label}
                    </MenuItem>
                ))}
            </Select> 
            :
            <CustomSelect
                {...this.props}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    transformOrigin: { vertical: "top", horizontal: "center" },
                    className: this.props.menuclasses
                }}
                renderValue={(selected) => {
                    if (this.props.multiple) {
                        return (
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                {selected.map(id => {
                                    return ( 
                                        <div key={id} style={{marginBottom: '5px', maxWidth: '100%'}}>                            
                                            <Chip
                                            key={id}
                                            label={this.props.options?.find(o => o.id === id)?.label}
                                            clickable
                                            deleteIcon={
                                                <CancelIcon
                                                    onMouseDown={(event) => event.stopPropagation()}
                                                />
                                                }
                                                onDelete={() => {
                                                    this.deleteItem(value);
                                                }}
                                            />   
                                            &nbsp;    
                                        </div>                 
                                    );
                                })}
                            </div>
                        )  
                    }                                                 
                }}
            >
                {this.props.children ?? this.props.options.map((o) => (
                    <MenuItem key={o.value + o.label} value={o.value}>
                        {o.label}
                    </MenuItem>
                ))}
            </CustomSelect>
        );
    }
}

export default CustomizedSelectWithChips;
